import { useRef } from 'react'

const useAddVariable = ({ onChange }) => {
  const editorRef = useRef()

  const onAddVariable = variable => {
    const quill = editorRef.current

    const range = quill.getSelection(true)

    if (range) {
      quill.insertEmbed(range.index, 'mention', {
        id: 1,
        value: variable.variable.replace('{{', ''),
        denotationChar: '{{',
      })
      quill.setSelection(range.index + 1)

      onChange({ html: quill.root.innerHTML, text: quill.root.innerText })
    }
  }

  return { editorRef, onAddVariable }
}

export default useAddVariable
